/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

var app = require('mag-app');

function replaceTitle ( str ) {
    str = str || '';

    return str.replace(/\//g, '-').replace(/\>/g, '-').replace(/</g, '-').replace(/\|/g, '-') // eslint-disable-line
        .replace(/\?/g, '-').replace(/\*/g, '-').replace(/\\/g, '-').replace(/\:/g, '-'); // eslint-disable-line
}

module.exports = function ( /*config*/ ) {
    var date = new Date(),
        day = date.getDate(),
        mon = date.getMonth() + 1,
        year = date.getFullYear(),
        min = date.getMinutes(),
        hour = date.getHours(),
        sec = date.getSeconds(),
        name,
        savePath,
        saveName;

    // config = config || {};

    if ( !app.playback.timeshift.active ) {
        return;
    }

    if ( app.lastPrimaryIntent && app.lastPrimaryIntent.data ) {
        name = app.lastPrimaryIntent.data.title || app.lastPrimaryIntent.data.uri;
    } else if ( app.currentPlayIntent && app.currentPlayIntent.data ) {
        name = app.currentPlayIntent.data.title || app.currentPlayIntent.data.uri;
    }

    name = replaceTitle(name);

    switch ( app.timeshift.onExit ) {
        case app.timeshift.EXIT_NOT_SAVE:
            app.timeshift.exit();
            break;
        case app.timeshift.EXIT_SAVE:
            savePath = app.timeshift.path + '/' + name + '/' + year + '-' + (mon > 9 ? mon : '0' + mon) + '-' + (day > 9 ? day : '0' + day) + '/';
            saveName = (hour > 9 ? hour : '0' + hour) + '-' + (min > 9 ? min : '0' + min) + '-' + (sec > 9 ? sec : '0' + sec);
            console.log('exit timeshift and save' + savePath);


            if ( app.timeshift.path && name ) {
                app.timeshift.exit({
                    save: {
                        path: savePath,
                        name: saveName
                    }
                });
            } else {
                app.timeshift.exit();
            }
            //
            break;
        case app.timeshift.EXIT_REQUEST_SAVE:

            //
            break;
    }


};
